module.exports = __webpack_public_path__ + "img/deleteacc.b5ff8f3f.svg";